import {onlyIfForm, useSelector} from '../../../../store.js'
import ConfirmModal from '../../../../common/components/Modal/ConfirmModal.js'
import ButtonPrimary from '../../../../common/components/Button/ButtonPrimary.js'
import TagFilterPanel from './TagFilterPanel.js'
import {
  closeModal,
  modalFormSelector,
  applyFilter,
  FILTERS_PANEL,
  WAREHOUSE_FILTER_PANEL,
  TAG_FILTER,
  MISC_FILTER_PANEL,
  clearFilters,
  STOCKTAKE_LIST_FILTER_OPTIONS,
} from './stocktakeListFilterModalFunctions.js'
import FiltersPanel from './FiltersPanel.js'
import WarehouseFilterPanel from './WarehouseFilterPanel.js'
import MiscFilterPanel from './MiscFilterPanel.js'
import {
  filterOrderSelector,
  showFilterSettingsModal,
} from '../../../Modals/FilterSettingsModal.js'
import Icon from '../../../../common/icons/Icon.js'

const FILTER_PANEL_LIST = {
  [FILTERS_PANEL]: FiltersPanel,
  [WAREHOUSE_FILTER_PANEL]: WarehouseFilterPanel,
  [TAG_FILTER]: TagFilterPanel,
  [MISC_FILTER_PANEL]: MiscFilterPanel,
}
const FILTER_ORDER_SETTINGS_KEY = 'stocktake.list.filter_order'

function showStocktakeListFilterSettingsModal() {
  showFilterSettingsModal({
    title: 'Stocktake Line Filter Settings',
    userSettingsKey: FILTER_ORDER_SETTINGS_KEY,
    listOptions: STOCKTAKE_LIST_FILTER_OPTIONS,
  })
}

function StocktakeListFilterModal() {
  const filterList = useSelector((state) =>
    filterOrderSelector(state, {
      userSettingsKey: FILTER_ORDER_SETTINGS_KEY,
      listOptions: STOCKTAKE_LIST_FILTER_OPTIONS,
    }),
  )

  return (
    <ConfirmModal
      title="Stocktake Filters"
      modalSize="md"
      className="modal--order-list-filters"
      onConfirm={() => applyFilter()}
      onCancel={() => closeModal()}
      confirmText="Apply"
      cancelText="Cancel"
      preventHotKeyConfirm
      RightButtons={() => (
        <div className="flex--justify">
          <ButtonPrimary
            isOutlined
            className="btn--sm margin-right-10"
            onClick={() => clearFilters()}
          >
            Clear Filters
          </ButtonPrimary>
          <ButtonPrimary
            isOutlined
            className="btn--sm"
            onClick={() => showStocktakeListFilterSettingsModal()}
          >
            <Icon name="sym-settings" className="fs-01" />
          </ButtonPrimary>
        </div>
      )}
    >
      {filterList.map((item) => {
        const Panel = FILTER_PANEL_LIST[item]

        return Panel ? <Panel key={item} /> : null
      })}
    </ConfirmModal>
  )
}

export default onlyIfForm(StocktakeListFilterModal, modalFormSelector)
